export const greenColor = "#597F3D"
export const blueColor = "#2970B3"
export const yellowColor = "#FFF67A"